<!--
 * @Author: Moustach_壮壮
 * @Date: 2024-04-07 22:27:24
 * @LastEditTime: 2024-04-23 00:56:02
 * @Description: file context
-->
<template>
  <router-view />
</template>

<script setup>
import { onMounted } from 'vue'
// import VConsole from "vconsole";
// let vc = null;
// const initVconsole = () => {
//   vc = new VConsole({
//     disableLogScrolling: false,
//     defaultPlugins: ["system", "network"],
//     log: { maxLogNumber: 200 },
//   });
// };
onMounted(() => {
  // initVconsole()
  // const devHeaderConfig = {
  //   'h-sign': '',
  //   'h-time': '1718283779',
  //   'h-bundle': 'com.buyvwu.ttccy|LSA-AN00|14|1.2.0',
  //   'h-device': 'android',
  //   'h-aid': '2bbd30f5608a534589df56d35a633df6c|ce6f0a9e-9c23-45c7-9fbf-508badfc5081|',
  //   'token':
  //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjksIm9zIjoiYW5kcm9pZCIsInRva2VuX3RpbWUiOjE3MTg1MzMxOTcsImlhdCI6MTcxODUzMzE5Nywic3ViIjoiY3lhcHAifQ.KmD0pXJtnpAt0-igipZ9t1NQxQv7N1Yjd4AmnkwnmzM',
  //   'h-channel': 'ccy',
  //   'vol_id': '',
  //   'device_type': '',
  //   'device_brand': '',
  // };
  // let queryKeys = ['h-bundle', 'h-aid', 'h-channel', 'token', 'vol_id', 'device_type', 'device_brand']
  // queryKeys.forEach(key => {
  //   if (devHeaderConfig[key]) { localStorage.setItem(key, devHeaderConfig[key]) }
  //   console.log(localStorage.getItem(key))
  // })
});
// onUnmounted(() => {
//   vc.destroy();
// });
// 安卓全局方法挂载
function setLoaclStorage (key, value) {
  localStorage.setItem(key, value)
}
function getLocalStorage (key) {
  return localStorage.getItem(key)
}
window.setLoaclStorage = setLoaclStorage
window.getLocalStorage = getLocalStorage
</script>

<style lang="scss">
// 引入scss文件
@import "./assets/styles/main.scss";

body {
  background-color: #f0f0f0;
  height: 100%;
  width: 100%;
  margin: 0px !important;
}
.f-r {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.f-r-c {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.f-r-b {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.f-c-c {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.header {
  height: 44px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.icon {
  width: 44px;
  height: 44px;
}
.m-t-12 {
  margin-top: 12px;
}
.f-z-17 {
  font-size: 20px;
}
.f-z-17 {
  font-size: 17px;
}
.f-z-16 {
  font-size: 16px;
}
.f-16 {
  font-size: 16px;
}
.f-12 {
  font-size: 12px;
}
.m-l-8 {
  margin-left: 8px;
}
</style>
